import HelpCentersPage from "./HelpCentersPage";

export default HelpCentersPage;
